// extracted by mini-css-extract-plugin
export default {"container":"Performance_container__zy-Tl","values":"Performance_values__OcrWq","header":"Performance_header__4juPZ"};